import "katex/dist/katex.min.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";
import App from "./App";
import "./index.css";
import "./styles/global.css";
import "./styles/main.scss";

TagManager.initialize({ gtmId: "GTM-WXPQ7P2" });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
